import { h, Component } from 'preact';
import cx from 'classnames';
import dlv from 'dlv';
import { Text } from 'preact-i18n';

import style from './style.less';

import SimpleVerticalCard from '../../cards/simple-vertical-card';
import HorizontalCard from '../../cards/horizontal-card';
import CardHeader from '../../pieces/card-header';
import { fetchArticleList } from '../../../lib/data';
import { fetchFromDailyMotionPlaylist } from '../../../lib/dailymotion';

import { TrackingProvider, DIMENSION } from '@cube/track';

/**
 * A X by Y grid of simple cards
 * @param {Object}  assets contents for the cards
 * @param {Integer} rowCount number of rows to display
 * @param {Integer} columnCount number of rows to display
*/
export default class SimpleGridCluster extends Component {

	state = {
		error: false,
		page: 1,
		assets: []
	};

	loadMore = () => {
		this.setState({ page: this.state.page + 1 });
		this.getAssets(this.props);
	};

	getAssets = (props) => {
		this.setState({
			error: false
		});

		if (props.isDailyMotion) {
			return fetchFromDailyMotionPlaylist({
				limit: props.rowCount * props.columnCount,
				page: this.state.page,
				...props }
			)
				.then( res => {
					if (res.articles && res.articles.length > 0) {
						this.setState({
							assets: this.state.assets.concat(res.articles),
							error: false
						});
						return;
					}
					this.setState({
						error: true
					});
				})
				.catch( error => {
					this.setState({
						error: true
					});
				});
		}

		let count = props.rowCount * props.columnCount;
		return fetchArticleList({
			count,
			offset: ((this.state.page - 1) * count) + (props.initialOffset || 0),
			imageSizes: props.imageRole,
			...props }
		)
			.then( res => {
				if (res.articles && res.articles.length > 0) {
					this.setState({
						assets: this.state.assets.concat(res.articles),
						error: false
					});
					return;
				}
				this.setState({
					error: true
				});
			})
			.catch( error => {
				this.setState({
					error: true
				});
			});
	};

	componentWillMount() {
		if (this.props.assets && this.props.assets.length > 0) {
			this.setState({
				assets: this.props.assets.slice(0, this.props.rowCount * this.props.columnCount)
			});
			return;
		}
		this.getAssets(this.props);
	}

	componentWillReceiveProps(nextProps) {
		if (dlv(nextProps, 'assets.0')) {
			this.setState({
				assets: nextProps.assets
			});
		}
	}

	render({ theme, rowCount, columnCount, showMore, title, titleIcon, clusterClass, qeId, cardOrientation, link, ...props }, { assets, error }) {
		if (error || !assets || assets.length === 0) return null;

		let Card = (cardOrientation === 'horizontal' ? HorizontalCard : SimpleVerticalCard);

		return (
			<TrackingProvider {...{ [DIMENSION.componentpath]: (title ? title.replace(/\s/g, '') + 'Cluster' : 'SimpleGridCluster') }}>
				<div class={cx(style.simpleGridCluster, clusterClass)} qid={qeId}>
					<CardHeader title={title} titleIcon={titleIcon} link={link} qeId={qeId} theme={theme} />
					<div class={cx(style.cards, rowCount > 1 && style.wrap, style['columns' + columnCount])}>
						{ assets.map((asset, i) => (
							<TrackingProvider {...{
								[DIMENSION.clickindex]: i+1
							}}
							>
								<Card
									theme={theme}
									asset={asset}
									qeId={qeId + '-' + i}
									{...props}
								/>
							</TrackingProvider>
						)) }
					</div>
					{ showMore && !error &&
						<div class={style.showMore} onClick={this.loadMore}>
							<Text id="moreStories" />
						</div>
					}
				</div>
			</TrackingProvider>
		);
	}
}
